<template>
  <s-select
    :value="value"
    :options="ddiCodes"
    value-field="code"
    text-field="name"
    @input="changeValue"
  >
    <template v-slot:content="item">
      <span class="select-content">
        {{ item.name }} ({{ item.dial_code }})
      </span>
    </template>
    <template v-slot:item="item">
      {{ item.name }} ({{ item.dial_code }})
    </template>
  </s-select>
</template>

<script>
import ddiCodes from '@/domain/data/user/ddi.json';

export default {
  data() {
    return {
      ddiCodes,
    };
  },
  props: {
    value: null,
  },
  methods: {
    changeValue(newVal) {
      this.$emit('input', newVal);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .select-content
    text-transform: none
    font-weight: normal
    color: var(--font-color-primary)
</style>
